var _rect, _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfilePicture(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 12,
    fill: "#009AD3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.809 38.714C25.654 37.714 30.367 37.8 37.221 38.749C37.7174 38.821 38.1709 39.0701 38.4979 39.4504C38.8249 39.8307 39.0033 40.3165 39 40.818C39 41.298 38.835 41.764 38.537 42.128C38.0176 42.7626 37.4855 43.3868 36.941 44H39.582C39.748 43.802 39.915 43.6 40.084 43.395C40.6772 42.6676 41.0007 41.7576 41 40.819C41 38.794 39.522 37.049 37.495 36.769C30.479 35.798 25.575 35.705 18.52 36.736C16.472 37.035 15 38.807 15 40.846C15 41.751 15.295 42.646 15.854 43.371C16.019 43.585 16.182 43.795 16.344 44.001H18.921C18.4144 43.3945 17.9203 42.7777 17.439 42.151C17.153 41.7758 16.9987 41.3168 17 40.845C17 39.768 17.774 38.865 18.809 38.714ZM28 29C28.7879 29 29.5681 28.8448 30.2961 28.5433C31.0241 28.2417 31.6855 27.7998 32.2426 27.2426C32.7998 26.6855 33.2417 26.0241 33.5433 25.2961C33.8448 24.5681 34 23.7879 34 23C34 22.2121 33.8448 21.4319 33.5433 20.7039C33.2417 19.9759 32.7998 19.3145 32.2426 18.7574C31.6855 18.2002 31.0241 17.7583 30.2961 17.4567C29.5681 17.1552 28.7879 17 28 17C26.4087 17 24.8826 17.6321 23.7574 18.7574C22.6321 19.8826 22 21.4087 22 23C22 24.5913 22.6321 26.1174 23.7574 27.2426C24.8826 28.3679 26.4087 29 28 29ZM28 31C30.1217 31 32.1566 30.1571 33.6569 28.6569C35.1571 27.1566 36 25.1217 36 23C36 20.8783 35.1571 18.8434 33.6569 17.3431C32.1566 15.8429 30.1217 15 28 15C25.8783 15 23.8434 15.8429 22.3431 17.3431C20.8429 18.8434 20 20.8783 20 23C20 25.1217 20.8429 27.1566 22.3431 28.6569C23.8434 30.1571 25.8783 31 28 31Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 46C37.941 46 46 37.941 46 28C46 18.059 37.941 10 28 10C18.059 10 10 18.059 10 28C10 37.941 18.059 46 28 46ZM28 48C39.046 48 48 39.046 48 28C48 16.954 39.046 8 28 8C16.954 8 8 16.954 8 28C8 39.046 16.954 48 28 48Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicture);
export default __webpack_public_path__ + "static/media/profilePicture.b2fa3b4123c95dfa644994bd839ec47e.svg";
export { ForwardRef as ReactComponent };